// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"4d08c3b9","338":"4d08c3b9"}[chunkId] + ".chunk.css";
};